import { createAction, props } from '@ngrx/store';
import { iItemsTypes } from 'src/app/pages/orders/order-taking/components/new-order/models/iItemsTypes.model';

export const loadOrderItemTypes = createAction('[Order Item Types] Load');

export const loadOrderItemTypesSuccess = createAction(
  '[Order Item Types] Load Success',
  props<{ response: iItemsTypes[] }>(),
);

export const loadOrderItemTypesSuccessByKey = createAction(
  '[Order Item Types] Load Success By Key',
  props<{ key: string; response: iItemsTypes[] }>(),
);

export const loadOrderItemTypesFailure = createAction('[Order Item Types] Load Failure', props<{ error: any }>());
